import { IHocSinhSelectRequest } from "../models/request/hoc-sinh/IHocSinhSelectRequest";
import { apiClient } from "./apiClient";


export const hocSinhApi = {
    Select: (request: IHocSinhSelectRequest) => apiClient.post('hoc-sinh/select', request),
    SelectById: (id: number) => apiClient.get(`hoc-sinh/${id}`),
    Search: (request: any) => apiClient.get(`hoc-sinh/search/truong/${request.dm_truong_id}/key/${request.key}`),
    SelectNhaphoc: (nam_hoc: string, dm_truong_id: number) => apiClient.get(`hoc-sinh/nhap-hoc/nam-hoc/${nam_hoc}/truong/${dm_truong_id}`),
/** Đồng bộ dữ liệu học sinh qua API Gateway access control */
    SyncToAccessControl: (dm_truong_id: number, nam_hoc: string) => apiClient.post(`hoc-sinh/sync-to-access-control/${dm_truong_id}/nam-hoc/${nam_hoc}`),

    /** Danh sách phụ huynh / người thân của 1 học sinh — thay cho `quan-he-gia-dinh/hoc-sinh/{id}` của adm */
    SelectPhuHuynhByHocSinh: (ts_hocsinh_id: number) => apiClient.get(`hoc-sinh/${ts_hocsinh_id}/phu-huynh`),

}